import { SVGProps } from "react";

export default function PptxFileIcon(props: SVGProps<SVGSVGElement>) {
  const { width = 16, height = 16, stroke = "#E3592E", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.93219 11.333H12.0589C13.3255 11.333 13.9922 10.6663 13.9922 9.39968V1.33301H1.99219V9.39968C1.99885 10.6663 2.66552 11.333 3.93219 11.333Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.33594 1.33301H14.6693"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.33594 14.6663L8.0026 13.333V11.333"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.6667 14.6663L8 13.333"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 7.33301L7.1 5.57967C7.26666 5.43967 7.48666 5.47967 7.6 5.66634L8.4 6.99967C8.51334 7.18634 8.73334 7.21968 8.9 7.08634L11 5.33301"
        stroke={stroke}
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
